import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './styles/global.css';

// Tesla 设计系统主题令牌：单色蓝 #3E6AE1、纯白/浅灰画布、零阴影、4px 圆角、字重 400/500
const TESLA_FONT = `-apple-system, BlinkMacSystemFont, 'Universal Sans Text', 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    locale={zhCN}
    theme={{
      token: {
        colorPrimary: '#3E6AE1',
        colorInfo: '#3E6AE1',
        colorLink: '#3E6AE1',
        colorLinkHover: '#5A7FE8',
        colorLinkActive: '#2F54C4',
        colorText: '#171A20',
        colorTextSecondary: '#393C41',
        colorTextTertiary: '#5C5E62',
        colorTextQuaternary: '#8E8E8E',
        colorBorder: '#D0D1D2',
        colorBorderSecondary: '#EEEEEE',
        colorBgLayout: '#F4F4F4',
        colorBgContainer: '#FFFFFF',
        colorBgElevated: '#FFFFFF',
        borderRadius: 4,
        fontFamily: TESLA_FONT,
        fontWeightStrong: 500,
        boxShadow: 'none',
        boxShadowSecondary: 'none',
        wireframe: false,
        motionDurationMid: '0.33s',
      },
      components: {
        Button: {
          controlHeightLG: 40,
          controlHeight: 36,
          fontWeight: 500,
          borderRadius: 4,
          primaryShadow: 'none',
          defaultShadow: 'none',
          dangerShadow: 'none',
        },
        Card: {
          borderRadiusLG: 12,
          boxShadowTertiary: '0 0 0 0 rgba(0,0,0,0)',
          paddingLG: 24,
        },
        Table: {
          headerBg: '#F4F4F4',
          headerColor: '#393C41',
          headerSplitColor: 'transparent',
          borderColor: '#EEEEEE',
          rowHoverBg: '#F7F8FA',
        },
        Modal: { borderRadiusLG: 12 },
        Input: { borderRadius: 4, controlHeight: 38 },
        InputNumber: { borderRadius: 4, controlHeight: 38 },
        Select: { borderRadius: 4, controlHeight: 38 },
        Layout: {
          siderBg: '#171A20',
          headerBg: '#FFFFFF',
          headerHeight: 64,
          bodyBg: '#F4F4F4',
        },
        Menu: {
          darkItemBg: '#171A20',
          darkSubMenuItemBg: '#101318',
          darkItemColor: 'rgba(255,255,255,0.68)',
          darkItemHoverColor: '#FFFFFF',
          darkItemHoverBg: 'rgba(62,106,225,0.22)',
          darkItemSelectedBg: '#3E6AE1',
          darkItemSelectedColor: '#FFFFFF',
          darkItemBorderRadius: 4,
          itemBorderRadius: 4,
        },
        Tabs: { itemColor: '#5C5E62', itemSelectedColor: '#171A20', inkBarColor: '#3E6AE1' },
        Tag: { borderRadiusSM: 4 },
      },
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>
);
